import styled from "styled-components";

export const ToastBox = styled.div`
  position: fixed;
  bottom: 40px;
  right: 10px;
  padding: 20px 30px;
  border: 1px solid var(--color-azul-mrpay);
  border-radius: 10px;
  background-color: white;
  justify-content: center;
  align-items: center;
  animation-name: fadeIn;
  animation-duration: 0.4s;
  animation-fill-mode: forwards;
  box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.5);

  @keyframes fadeIn {
    from {
      display: none;
      opacity: 0;
    }
    to {
      opacity: 1;
      display: flex;
    }
  }

  @media screen and (max-width: 820px) {
    bottom: 10px;
    padding: 10px 15px;
    font-size: 16px;
  }
`;
